export default {
    state: {
        list: null,

        count: null,

        filters: {
            type: undefined,
            status: undefined,
            query: undefined,
        },
    },

    mutations: {
        SYSTEMWARNING_SET_LIST(state, list) {
            state.list = list;
        },

        SYSTEMWARNING_SET_COUNT(state, count) {
            state.count = count;
        },

        SYSTEMWARNING_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },

        SYSTEMWARNING_RESET_FILTERS(state) {
            state.filters = {
                type: undefined,
                status: undefined,
            };
        },
    },

    getters: {},
};
